<template>
  <div :class="'js-cart-product space-between flex-row cart-product-row' + (isEditable ? ' editable-product-row' : ' ') + itemType + itemExtras + (folioSelectMode ? ' folio-select-mode' : '') + (folioSelectMode && hasParentItem ? ' folio-sub-row' : '') + (showFolioCheckbox && !folioLocked ? ' folio-selectable-row' : '') + ((showFolioCheckbox || (folioSelectMode && hasParentItem)) && folioSelected ? ' folio-selected-row' : '')" :role="showFolioCheckbox ? 'checkbox' : null" :aria-checked="showFolioCheckbox ? folioSelected : null" :tabindex="showFolioCheckbox ? 0 : null" v-on:click="onCartRowClick" v-on:keydown.enter="onCartRowKeydown" v-on:keydown.space="onCartRowKeydown">
    <div class="folio-item-select" v-if="showFolioCheckbox">
      <input type="checkbox" :checked="folioSelected" :disabled="folioLocked" tabindex="-1" aria-hidden="true">
    </div>
    <div class="js-cart-product-content flex-1 " :data-product="item.product_id">
      <div :class="'product-name-wrap ' + productNameExtras" v-if="(isReadOnly || !isTicket || folioSelectMode) && !itemModificationEnabled">
        <div class="cart-product-details">
          <div class="cart-product-name" v-html="item.product_name"></div>
          <div v-if="!isPackaged" class="js-cart-product-unit" v-show="isReadOnly || !isTicket || folioSelectMode" v-html="displayedCount"></div>
          <div class="js-cart-product-description" v-if="item.reservation_desc && !itemModificationEnabled">
            <template v-if="isPackaged">
              <span class="description-times" v-html="getPackageItemDesc(item)" style="margin-top: -10px; padding-bottom: 5px; display: block"></span>
            </template>
            <template v-else>
              <span class="description-rateplan" v-if="isRateplanNameVisible">{{ item.rateplan_name }}</span>
              <span class="description-times" v-html="getFullReservationDesc(item)"></span>
              <ul class="description-participants" v-if="item.pricetiers">
                <li v-for="pricetier in priceTiers"><span class="participant-name" v-html="pricetier.name"></span><span class="participant-count" v-html="pricetier.count"></span></li>
              </ul>
              </template>
          </div>
          <div class="cart-product-warnings" v-if="itemWarnings.length">
            <span class="cart-product-warning" v-for="warning in itemWarnings"><i class="fa fa-fw fa-warning"></i> {{ warning }}</span>
          </div>
          <div class="js-cart-product-seats" v-if="isSeatInformationVisible">
            <div class="btn-group">
              <template v-for="resource in resources">
                <a class="btn btn-sm bg-info" href="javascript:;"><i class="fa fa-fw fa-cube"></i> {{ resource.name }}</a>
                <a class="btn btn-sm bg-info" href="javascript:;" v-for="seat in getResourceSeats(resource)" v-html="getSeatName(resource, seat).replace(' ', '&nbsp;')"></a>
              </template>
            </div>
          </div>
        </div>
        <span class="cart-price-wrap" v-if="hasVisiblePricing">
          <span class="cart-product-price-vatfree" v-if="showVatFreePrices"><span>{{ $filters.currency(totalVatFree, item.currency) }}</span><span class="cart-item-vat">{{ _('vat') }} 0%</span></span>
          <span class="cart-product-price" v-if="showVatPrices"><span>{{ $filters.currency(validatedPrice(item.price) * item.count * multiple, item.currency) }}</span><span class="cart-item-vat">{{ _('vat') }} {{ formatVat(item.vat, numberFormat) }} %</span></span>
        </span>
      </div>
      <div class="item-modify-row" v-if="isTicket && !itemModificationEnabled && !isReadOnly && !folioSelectMode">
        <div class="item-modify-ticket">
          <span class="input-group-btn split-item-wrap" v-if="item.count > 1">
            <button class="btn btn-info split-item" v-on:click="expandItem"><i class="fa fa-fw fa-bars"></i></button>
          </span>
          <multiselect class="form-control undercover" :model-value="ticketOptions.find( _ => _.id === selectedTicketProductId )" :show-labels="false" :searchable="false" :allow-empty="false" :multiple="false" label="name" track-by="id" @update:modelValue="modifyTicketItem" :options="ticketOptions"></multiselect>
          <span class="cart-price-wrap" v-if="hasVisiblePricing" v-on:click="enableItemModification">
            <span class="cart-product-price-vatfree" v-if="showVatFreePrices"><span>{{ $filters.currency(totalVatFree, item.currency) }}</span><span class="cart-item-vat">{{ _('vat') }} 0%</span></span>
            <span class="cart-product-price" v-if="showVatPrices"><span>{{ $filters.currency(validatedPrice(item.price) * item.count * multiple, item.currency) }}</span><span class="cart-item-vat">{{ _('vat') }} {{ formatVat(item.vat, numberFormat) }} %</span></span>
          </span>
        </div>
      </div>
      <div v-if="itemModificationEnabled && !isReadOnly && !folioSelectMode" class="item-modify">
        <form v-on:submit.prevent>
          <div class="item-modify-row">
            <div class="item-modify-name has-float-label">
              <input ref="productname" type="text" class="form-control" :placeholder="_('Item title')" v-model="item.product_name" :disabled="!isFreeformItem" />
              <label>{{ _('Item title') }}</label>
            </div>
            <div class="item-modify-count has-float-label" v-if="isCountEditable" >
              <decimal-input ref="count" v-model="item.count" :step="1" :placeholder="_('Amount')"></decimal-input>
              <label>{{ _('Amount') }}</label>
            </div>
          </div>
          <div class="item-modify-row item-modify-details" v-if="isReservation || !isSpecialEditorVisible">
            <div class="details-column details-reservation" v-if="isReservation">
              <div class="detail">
                <div class="detail-label">{{ _('Reservation time') }}</div>
                <div class="detail-value">{{ getFullReservationDesc(item) }}</div>
              </div>
              <div class="detail" v-if="isRateplanNameVisible">
                <div class="detail-label">{{ _('Rate plan') }}</div>
                <div class="detail-value">{{ item.rateplan_name }}</div>
              </div>
              <div class="detail">
                <div class="detail-label">{{ _('Participants') }}</div>
                <div class="detail-value">
                  <ul class="description-participants" v-if="item.pricetiers">
                    <li v-for="pricetier in priceTiers"><span class="participant-name" v-html="pricetier.name"></span><span class="participant-count" v-html="pricetier.count"></span></li>
                  </ul>
                  <template v-else>
                    {{ item.reservation_count }}
                  </template>
                </div>
              </div>
            </div>
            <div class="details-column details-extra" v-if="!isSpecialEditorVisible">
              <div class="detail">
                <template v-if="item.special">
                  <div class="detail-label">{{ _('Additional info') }}</div>
                  <div class="detail-value"><a href="javascript:;" v-on:click="editSpecial">{{ item.special ? item.special : _('empty') }}</a></div>
                </template>
                <button class="btn btn-xs btn-primary" v-on:click="editSpecial" v-else>{{ _('Additional info') }}</button>
              </div>
            </div>
          </div>
          <div class="item-modify-row item-modify-details" v-if="isSpecialEditorVisible">
            <div class="item-modify-name has-float-label">
              <textarea class="form-control" v-model="item.special" rows="3" wrap="virtual"></textarea>
              <label>{{ _('Additional info') }}</label>
            </div>
          </div>
          <template v-if="isOptionGroupEditorVisible">
            <div class="item-modify-row item-section-title">{{ _('Product options') }} <i class="fa fa-fw fa-refresh fa-spin" v-if="optionsLoading || optionsBusy"></i></div>
            <div class="item-modify-row item-modify-option" v-for="group in optionGroups" :key="group.id">
              <div class="item-modify-name has-float-label" v-if="groupSelectOptions(group).length">
                <select class="form-control" :value="groupChoiceId(group)" :disabled="optionsBusy" v-on:change="chooseGroupOption(group, $event.target.value)">
                  <option value="" :disabled="group.required && !!groupChoiceId(group)">{{ group.required ? _('Select...') : _('No selection') }}</option>
                  <option v-for="option in groupSelectOptions(group)" :key="option.id" :value="option.id" :disabled="option.disabled">{{ option.label }}</option>
                </select>
                <label>{{ group.name }}<template v-if="group.required"> *</template></label>
              </div>
              <div class="item-modify-note" v-if="group.unsupported">{{ group.name }}: {{ _('Some options of this group cannot be selected in the order editor.') }}</div>
            </div>
          </template>
          <template v-if="hasForm">
            <div class="item-modify-row item-section-title" v-html="item.form.name"></div>
            <template v-for="(field, index) in formFields" :key="index">
              <div class="item-modify-row item-modify-formfield" v-if="isFormFieldVisible(field)">
                <div class="item-modify-name has-float-label" v-if="isFormInputField(field)">
                  <input class="form-control" :type="field.type" v-model="formData[field.title]" placeholder=" " />
                  <label>{{ field.title }}<template v-if="isMandatoryFormField(field)"> *</template></label>
                </div>
                <div class="item-modify-name has-float-label" v-if="isFormTextArea(field)">
                  <textarea class="form-control" wrap="virtual" rows="3" v-model="formData[field.title]" placeholder=" "></textarea>
                  <label>{{ field.title }}<template v-if="isMandatoryFormField(field)"> *</template></label>
                </div>
                <div class="item-modify-name has-float-label" v-if="isFormSelectField(field)">
                  <select class="form-control" v-model="formData[field.title]">
                    <option value="">{{ _('Select...') }}</option>
                    <option v-for="option in parseFormOptions(field.options)" :value="option">{{ option }}</option>
                  </select>
                  <label>{{ field.title }}<template v-if="isMandatoryFormField(field)"> *</template></label>
                </div>
                <div class="checkbox item-modify-checkbox" v-if="isFormCheckbox(field)">
                  <label>
                    <input type="checkbox" v-model="formData[field.title]" true-value="1" false-value="0" />
                    <span v-html="field.title + (isMandatoryFormField(field) ? ' *' : '')"></span>
                  </label>
                </div>
                <p v-if="field.type === 'static'" v-html="field.text"></p>
                <h3 v-if="field.type === 'h3' && field.text" v-html="field.text"></h3>
              </div>
            </template>
          </template>
          <div class="item-modify-row" v-if="isPriceVisible">
            <div class="item-modify-vat has-float-label" v-if="isVatEditable">
              <select class="form-control" v-model="item.vat" :disabled="isDiscount">
                <option v-for="vat in vats" :value="vat">{{ formatVat(vat, numberFormat) }} %</option>
              </select>
              <label>{{ _('Vat (%)') }}</label>
            </div>
            <div class="item-modify-itemprice has-float-label">
              <decimal-input ref="vatfreeprice" v-model="vatFreePrice" :disabled="isDiscount"></decimal-input>
              <label>{{ _('Unit price') }}</label>
            </div>
            <div class="item-modify-itempricevat has-float-label">
              <decimal-input ref="unitprice" v-model="item.price" :disabled="isDiscount"></decimal-input>
              <label>{{ _('Unit price (inc. vat)') }}</label>
            </div>
            <div class="item-modify-totalprice">
              <div class="input-group has-float-label">
                <input type="text" step="any" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" v-model="totalPrice">
                <label>{{ _('Total (inc. vat)') }}</label>
                <span class="input-group-addon">{{ $filters.currencySymbol(item.currency) }}</span>
              </div>
              <div class="totalprice-tax" style="cursor: pointer;"><span v-on:click="setVatFreePriceDialog">{{ $filters.currency(totalVatFree, item.currency) }}</span> <span>{{ _('vat') }} 0%</span></div>
            </div>
          </div>
          <div class="item-modify-row" v-if="isDiscountSelectorAvailable">
            <div class="item-modify-discount">
              <discount-selector :item="item" :allItems="allItems" :locale="locale" :shopId="shopId" :baseDomain="baseDomain" :billingCustomer="billingCustomer" />
            </div>
          </div>
          <div class="item-modify-row" v-if="isNetvisorVisible">
            <div class="item-modify-netvisoraccount has-float-label">
              <select class="form-control" v-model="item.netvisoraccount">
                <option v-for="account in netvisorAccounts" :disabled="account.accounttype === 'accountgroup'" :value="account.number" v-html="accountTitle(account)"></option>
              </select>
              <label>{{ _('Netvisor account') }}</label>
            </div>
            <div class="item-modify-netvisordimension has-float-label">
              <select class="form-control" v-model="item.netvisorvatcode">
                <option v-for="(desc, vatcode) in netvisorVatcodes" :value="vatcode">{{ desc }}</option>
              </select>
              <label>{{ _('VAT handling') }}</label>
            </div>
          </div>
          <div class="item-modify-row" v-if="isLoyaltyVisible">
            <div class="item-modify-netvisoraccount has-float-label">
              <select class="form-control" v-model="item.loyalty">
                <option value="">{{ _('Not eligible') }}</option>
                <option value="bonus">{{ _('Bonus') }}</option>
                <option value="both" v-if="isPaymentMethodBenefitEnabled">{{ _('Bonus and payment method benefit') }}</option>
              </select>
              <label>{{ _('Bonus') }}</label>
            </div>
          </div>
          <div class="item-modify-row item-modify-shipping" v-if="hasShipments">
            <div class="item-modify-name has-float-label">
              <select class="form-control" v-model="item.delivery_id">
                <optgroup :label="_('Deliveries')">
                  <option v-for="shipment in shipments.filter(s => s.delivery)" :value="shipment.delivery.id">{{ _('Delivery') }} {{ shipment.number }}<template v-if="shipment.deliverymethod">: {{ shipment.deliverymethod.name }}</template></option>
                </optgroup>
                <optgroup :label="_('New delivery')">
                  <option v-for="deliverymethod in deliverymethods" :value="'new-' + deliverymethod.id">{{ deliverymethod.name }}</option>
                </optgroup>
              </select>
              <label>{{ _('Delivery method') }}</label>
            </div>
          </div>
          <div class="item-modify-row item-confirm-buttons">
            <div class="item-modify-ok"><button class="btn btn-primary" v-on:click="saveItem" :disabled="!isOkButtonEnabled">{{ _('OK') }}</button></div>
            <div class="item-modify-cancel"><button class="btn btn-default" v-on:click="cancel">{{ _('Cancel') }}</button></div>
          </div>
        </form>
      </div>
      <a href="javascript:;" class="btn btn-sm btn-danger js-cart-product-remove" v-on:click="deleteItem()" v-show="!itemModificationEnabled" v-if="isDeletable && !folioSelectMode"><span class="fa fa-fw fa-close"></span><span class="hidden">{{ _('Delete') }}</span></a>
      <a href="javascript:;" class="btn btn-sm btn-danger js-cart-product-remove" style="background-color: #999" v-if="!isReal"><div class="fa fa-fw fa-refresh fa-spin"></div></a>
      <a href="javascript:;" class="js-cart-product-modify-easyaccess" v-on:click="enableItemModification" v-show="!itemModificationEnabled" v-if="isEditable && !isTicket && !folioSelectMode"></a>
    </div>
    <button class="btn btn-xs btn-default extract-button" type="button" v-on:click="extractTicket(item)" v-if="isExtractionAvailable && !folioSelectMode"><i class="fa fa-fw fa-ticket"></i> {{ _('Extract') }}</button>
  </div>
</template>

<script>
import axios from 'axios'
import escapeHtml from '~/lib/escapehtml'
import { Decimal } from 'decimal.js'
import { mapGetters } from 'vuex'
// import jQuery from 'jquery'
import debounce from 'lodash/debounce'
import Multiselect from 'vue-multiselect'
import { DateTime } from 'luxon'
import constants from '~/lib/constants'
import errors from '~/lib/errors'
import formats from '~/lib/formats'
import netvisor from '~/lib/netvisor'
import settingshelpers from '~/lib/settingshelpers'
// import DecimalInput from '~/components/DecimalInput'
// import DiscountSelector from '~/components/DiscountSelector'

// Vue.use(VueLazyLoad)

export default {
  data () {
    return {
      isOpen: false,
      upsellProductCache: null,
      itemModificationEnabled: false,
      basketItemModifiedHandler: null,
      origCount: null,
      origPrice: null,
      origVat: null,
      origProductName: null,
      origSpecial: null,
      origNetvisorAccount: null,
      origNetvisorVatcode: null,
      origLoyalty: null,
      origDelivery: null,
      ticketProducts: [],
      selectedTicketProductId: null,
      isSpecialEditorVisible: false,
      formData: {},
      origFormData: '{}',
      optionProduct: null,
      optionsLoading: false,
      optionsBusy: false,
      item: {}
    }
  },
  mixins: [constants, errors, formats, netvisor, settingshelpers],
  props: ['readonly', 'hasShipments', 'shipments', 'deliverymethods', 'allItems', 'currItem', 'leftcolwidth', 'rightcolwidth', 'settings', 'shopId', 'masterShopId', 'baseDomain', 'locale', 'context', 'index', 'parent', 'billingCustomer', 'receiptData', 'accounts','isVatVisible', 'folioSelectable', 'folioSelected', 'folioSelectMode', 'folioLocked'],
  components: {
    Multiselect,
  },
  methods: {
    toggleFolioSelect () {
      this.$emit('folioToggle')
    },
    onCartRowClick () {
      if (!this.showFolioCheckbox || this.folioLocked) {
        return
      }
      this.toggleFolioSelect()
    },
    onCartRowKeydown (event) {
      if (!this.showFolioCheckbox) {
        return
      }
      const target = event.target
      if (target && typeof target.closest === 'function' && target.closest('input, textarea, select, [contenteditable="true"]')) {
        return
      }
      event.preventDefault()
      this.onCartRowClick()
    },
      cleanAndConvertNumber (input) {
      // Remove all non-numeric characters except for the first decimal point and the first minus sign
      let cleaned = input.replace(/[^0-9.,-]/g, '');

      // Preserve the first dash if it appears at the beginning
      let prefix = ''
      if (cleaned.startsWith('-')) {
        prefix = '-'
      }
      cleaned = prefix + cleaned.replace(/-/g, '')

      // Replace multiple commas or points with a single point
      cleaned = cleaned.replace(/,+/g, '.').replace(/\.+/g, '.')

      // Remove any commas
      cleaned = cleaned.replace(/,/g, '');

      // Handle the case where there are multiple decimal points
      const parts = cleaned.split('.');
      if (parts.length > 2) {
          cleaned = parts[0] + '.' + parts.slice(1).join('')
      }

      // Convert to a number
      let number = parseFloat(cleaned);

      // If the number is not valid, return 0
      if (isNaN(number)) {
          number = 0
      }

      return number
    },
    setVatFreePriceDialog () {
      this.showDialog({
        title: this._('Set VAT-free price'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['price'],
            handler: (data) => {
              this.setVatFreePrice(data.price)
            }
          }
        ],
        fields: [
          {
            title: this._('Price'),
            type: 'number',
            name: 'price',
            defaultValue: this.totalVatFree
          }
        ]
      })
    },
    setVatFreePrice (price) {
      this.totalPrice = price * (1 + this.item.vat / 100)
    },
    getSeatName(resource, seat) {
      if (resource.seatmap) {
        const data = JSON.parse(resource.seatmap.data)
        if (data && data.seats) {
          const s = data.seats.find(s => parseInt(s.seat, 10) === parseInt(seat.id))
          if (s) {
            return s.header + ' / ' + s.title
          }
        }
      }
      return ''
    },
    getResourceSeats (resource) {
      if (resource.seatmap_id && this.seats && this.seats.length) {
        return this.seats.filter(s => s.resource_id === resource.id)
      }
      return []
    },
    getPackageItemDesc (item) {
      if (!item?.packages) {
        return ''
      }
      const itemData = JSON.parse(item.packages)
      const itemRef = itemData.itemRef
      const mainItem = this.allItems?.find(i => i.id == item.item_id)
      if (!mainItem) {
        return ''
      }
      const packageData = JSON.parse(mainItem.packages)
      for (const participant of packageData) {
        for (const product of participant.products) {
          if (product.itemRef === itemRef) {
            const resourcePoolName = product.resourcePools.length > 0 ? ', ' + product.resourcePools[0].name : '';
            return escapeHtml(participant.name) + escapeHtml(resourcePoolName);
          }
        }
      }
      return ''
    },
    getFullReservationDesc (item) {
      let res = false
      if (item && item.ownReservation && item.ownReservation[0]) {
        res = item.ownReservation[0]
        if (res.start_ts != item.start_ts || res.end_ts != item.end_ts) {
          return DateTime.fromSeconds(Number(res.start_ts), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' +  this._('at') + ' ' + DateTime.fromSeconds(Number(res.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) + ' - ' + 
                 (DateTime.fromSeconds(Number(res.start_ts), { zone: this.timezone }).toFormat('yyyy/MM/dd') !== DateTime.fromSeconds(Number(res.end_ts), { zone: this.timezone }).toFormat('yyyy/MM/dd') ? DateTime.fromSeconds(Number(res.end_ts), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' +  this._('at') : '') + ' ' + DateTime.fromSeconds(Number(res.end_ts), { zone: this.timezone }).toFormat(this.timeFormat) +
                 '<small style="color: #666; font-weight: normal">' +
                 ' (' + this._('was') + ': ' + this.getReservationDesc(item) + ')' +
                 '</small>'
        }
      }
      if (item && item.start_ts && item.end_ts) {
        return this.getReservationDesc(item)
      }
      return item.reservation_desc
    },
    getReservationDesc (item) {
      let s = ''
      const _ = this._
      const sd = DateTime.fromSeconds(Number(item.start_ts), { zone: this.timezone })
      let ed = DateTime.fromSeconds(Number(item.end_ts), { zone: this.timezone })
      let et = ed.toFormat(this.timeFormat)
      if (et === '0.00') {
        et = '24.00'
        ed = ed.minus({ days: 1 })
      }
      s += sd.toFormat(this.dateFormat) + ' ' + _('at') + ' ' + sd.toFormat(this.timeFormat)
      s += ' - '
      if (sd.toFormat('yyyy/MM/dd') !== ed.toFormat('yyyy/MM/dd')) {
        s += ed.toFormat(this.dateFormat) + ' ' + _('at') + ' '
      }
      s += et
      return s
    },
    editSpecial () {
      this.isSpecialEditorVisible = true
    },
    extractTicket (item) {
      this.$emit('extractTicket', item)
    },
    validatedPrice (n) {
      return parseFloat(String(n).replace(/,/g, '.'))
    },
    getPricetierName (pricetierId, shopId) {
      let s = this.settings
      if (!s || !s.ownPricetier) {
        return ''
      }
      for (var i = 0; i < s.ownPricetier.length; i++) {
        if (parseInt(s.ownPricetier[i].id, 10) === parseInt(pricetierId, 10)) {
          return s.ownPricetier[i].name
        }
      }
      return ''
    },
    reloadBasket () {
    },
    async enableItemModification () {
      if (this.folioSelectMode || parseInt(this.selfService)) {
        return
      }
      let item = this.item
      let shopId = this.shopId
      this.itemModificationEnabled = true
      this.origCount = item.count
      this.origPrice = item.price
      this.origVat = item.vat
      this.origProductName = item.product_name
      this.origSpecial = item.special
      this.origNetvisorAccount = item.netvisoraccount
      this.origNetvisorVatcode = item.netvisorvatcode
      this.origLoyalty = item.loyalty
      this.origDelivery = item.delivery_id
      this.formData = this.parseFormResponse(item.formresponse)
      this.origFormData = JSON.stringify(this.formData)
      if (this.hasOptionGroupLinks) {
        this.loadOptionProduct()
      }
      await nextTick()
      if (this.$refs && this.$refs.productname) {
        this.$refs.productname.focus()
      }
    },
    async showTicketOptions () {
      if (this.isTicket) {
        let item = this.item
        let shopId = this.shopId
        this.ticketProducts = []
        this.selectedTicketProductId = this.item.product_id
        let parentItem = this.findParentItem()
        if (parentItem) {
          if (parentItem.show_id) {
            let showResponse = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/shows/' + parentItem.show_id + '.json?details=true' + (item.zone_id ? '&zone=' + item.zone_id : ''))
            let show = showResponse.data
            if (show && show.pricing) {
              this.ticketProducts = show.pricing.sharedProduct
            }
          } else {
            let endDateStr = ''
            let mode = 'hours'
            if (parentItem.product_unittype == this.UNIT_DAY) {
              endDateStr = '&enddate=' + parentItem.end_ts
              mode = 'days'
            }
            let startTime = parentItem.reservation_timestart
            let endTime = parentItem.reservation_timeend
            let priceResponse = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products/' + parentItem.product_id + '/fullprices.json' +
                                                '?date=' + parentItem.start_ts + endDateStr + '&starttime=' + startTime + '&endtime=' + endTime + '&mode=' + mode +
                                                '&resource_count=' + parentItem.resource_count + '&reservation_count=' + parentItem.reservation_count + 
                                                '&client=' + this.clientId + '&shop=' + this.masterShopId)
            let fullprices = priceResponse.data
            if (fullprices && fullprices.prices && fullprices.prices.detail && fullprices.prices.detail[0] && fullprices.prices.detail[0].tickets) {
              this.ticketProducts = fullprices.prices.detail[0].tickets
            }
          }
        }
      }
    },
    findParentItem () {
      if (this.allItems && this.allItems.length) {
        for (var i = 0; i < this.allItems.length; i++) {
          if (this.allItems[i].id === this.item.item_id) {
            return this.allItems[i]
          }
        }
      }
      return null
    },
    findChildren () {
      let childItems = []
      if(typeof this.allItems === "undefined") return childItems
      if (this.allItems && this.allItems.length) {
        for (var i = 0; i < this.allItems.length; i++) {
          if (this.allItems[i].item_id === this.item.id) {
            childItems.push(this.allItems[i])
          }
        }
      }
      return childItems
    },
    findSiblings () {
      let siblingItems = []
      if(typeof this.allItems === "undefined") return siblingItems
      for (var i = 0; i < this.allItems.length; i++) {
        if (this.allItems[i].item_id == this.item.item_id || this.allItems[i].id === this.item.id) {
          siblingItems.push(this.allItems[i])
        }
      }
      return siblingItems
    },
    saveItem () {
      if (this.item) {
        if (this.item.id !== 'new') {
          return this.modifyItem()
        }
        return this.addItem()
      }
    },
    cancel () {
      this.itemModificationEnabled = false
    },
    async modifyItem () {
      let item = this.item
      let shopId = this.shopId
      if (this.origCount !== item.count || this.origPrice !== item.price || this.origVat !== item.vat || this.origProductName !== item.product_name || this.origSpecial !== item.special || this.origNetvisorAccount !== item.netvisoraccount || this.origNetvisorVatcode !== item.netvisorvatcode || this.origLoyalty !== item.loyalty || this.origDelivery !== item.delivery_id) {
        if (item.count === 0) {
          this.deleteItem()
        } else {
          item.price = this.validatedPrice(item.price)
          try {
            const data = {
              locale: this.locale,
              shopId: shopId,
              masterShopId: this.masterShopId,
              id: item.id,
              count: item.count,
              price: item.price,
              vat: item.vat,
              special: item.special
            }
            if (item.delivery_id) {
              if (!parseInt(item.delivery_id)) { // Create a new delivery first if the value is 'new-[eliverymethodid]'
                const [, deliverymethodId] = item.delivery_id.split('-')
                try {
                  const deliveryData = {
                    deliverymethod_id: deliverymethodId
                  }
                  let response = await axios.post(this.baseDomain + shopId + '/deliveries.json?apikey=' + this.apiKey, deliveryData)
                  data.deliveryId = response.data
                } catch (e) {
                  console.log(e)
                }
              } else if (parseInt(item.delivery_id)) { // This either remains the same, or we switched to another delivery
                data.deliveryId = item.delivery_id
              }
            }
            if (this.isFreeformItem) {
              data.productName = item.product_name
              if (this.isNetvisorVisible) {
                data.netvisorAccount = item.netvisoraccount
                data.netvisorVatcode = item.netvisorvatcode
              }
              if (this.isLoyaltyVisible) {
                data.loyalty = item.loyalty
              }
            }
            await this.$store.dispatch('modifyBasketItem', data)
          } catch (err) {
            this.showAddedToBasketError(err)
          }
        }
        this.EventBus.$emit('basketItemModified', { item: item, shopId: shopId })
      }
      if (Number(item.count) !== 0) {
        await this.saveFormResponse()
      }
      this.itemModificationEnabled = false
    },
    /**
     * Save the answers of the product form (JDEV-3245). They are stored like the storefront stores them: an object
     * keyed by field title. Missing mandatory answers are only warned about, they never block the sale.
     */
    async saveFormResponse () {
      if (!this.hasForm || !this.item.id || this.item.id === 'new') {
        return
      }
      const answers = Object.assign({}, this.formData)
      if (JSON.stringify(answers) === this.origFormData) {
        return
      }
      const state = this.$store.state
      const basketId = state.basketIds[this.shopId + '-' + state.activeBasket]
      if (!basketId) {
        return
      }
      let queryStr = 'client=' + state.clientid + '&apikey=' + this.apiKey
      if (this.shopId !== state.shopId) {
        queryStr += '&shop=' + state.shopId
      }
      if (state.activeOrder) {
        queryStr += '&orderidentifier=' + state.activeOrder.identifier
      }
      try {
        // The answers must always be sent as an object: a PATCH without formresponse unlinks the item from the basket
        await axios.patch(this.baseDomain + this.shopId + '/' + this.locale + '/baskets/' + basketId + '/items/' + this.item.id + '.json?' + queryStr, {
          id: this.item.id,
          formresponse: answers
        })
        this.item.formresponse = answers
        this.origFormData = JSON.stringify(answers)
      } catch (err) {
        this.showError(err)
        return
      }
      await this.$store.dispatch('reloadBasket', this.shopId + '-' + state.activeBasket)
    },
    parseFormResponse (value) {
      if (!value) {
        return {}
      }
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value)
        } catch (e) {
          return {}
        }
      }
      if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return {}
      }
      return Object.assign({}, value)
    },
    isMandatoryFormField (field) {
      return !!(field && parseInt(field.mandatory || '0', 10))
    },
    isFormInputField (field) {
      return !!field && ['text', 'email', 'number', 'password'].includes(field.type)
    },
    isFormCheckbox (field) {
      return !!field && field.type === 'checkbox'
    },
    isFormTextArea (field) {
      return !!field && field.type === 'textarea' && field.editor !== 'richEditor'
    },
    isFormSelectField (field) {
      return !!field && field.type === 'select' && !!field.options
    },
    isFormAnswerField (field) {
      return this.isFormInputField(field) || this.isFormCheckbox(field) || this.isFormTextArea(field) || this.isFormSelectField(field)
    },
    isFormFieldVisible (field) {
      return this.isFormAnswerField(field) || (!!field && (field.type === 'static' || (field.type === 'h3' && !!field.text)))
    },
    isFormFieldMissing (field, answers) {
      if (!this.isMandatoryFormField(field) || !this.isFormAnswerField(field)) {
        return false
      }
      const value = answers ? answers[field.title] : undefined
      if (this.isFormCheckbox(field)) {
        return String(value) !== '1'
      }
      return value === undefined || value === null || String(value).trim() === ''
    },
    parseFormOptions (options) {
      return String(options || '').split('\n').map(o => o.replace(/\r$/, '')).filter(o => o)
    },
    async loadOptionProduct () {
      if (this.optionProduct && String(this.optionProduct.id) === String(this.item.product_id)) {
        return
      }
      this.optionsLoading = true
      try {
        const response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products/' + this.item.product_id + '.json?apikey=' + this.apiKey)
        this.optionProduct = response.data
      } catch (e) {
        console.log(e)
        this.optionProduct = null
      }
      this.optionsLoading = false
    },
    /**
     * Options that can be added from the order editor: buyable products. Reservable options need a time range and
     * pick-up / drop-off places need a stop, so those are left to the booking flow.
     */
    isPickableOption (product) {
      return !!product && parseInt(product.type, 10) === this.TYPE_BUYABLE && parseInt(product.subtype, 10) !== this.SUBTYPE_TICKET
    },
    // Option count like the storefront calculates it (FixedBuyableOption)
    optionCount (link) {
      const multiply = link && link.multiply ? String(link.multiply) : ''
      if (!multiply) {
        return this.isReservation ? 1 : (parseFloat(this.item.count) || 1)
      }
      let count = 1
      const multi = multiply.split(',')
      if (multi.includes('days')) {
        count *= this.parentDays
      }
      if (multi.includes('participants')) {
        count *= parseInt(this.item.reservation_count, 10) || 1
      }
      if (multi.includes('resources')) {
        count *= parseInt(this.item.resource_count, 10) || 1
      }
      return count
    },
    groupChildItems (group) {
      if (!this.allItems || !this.item.id) {
        return []
      }
      return this.allItems.filter(i => i && i.item_id && String(i.item_id) === String(this.item.id) && group.optionIds.includes(String(i.product_id)))
    },
    groupChoiceId (group) {
      const child = this.groupChildItems(group)[0]
      return child ? String(child.product_id) : ''
    },
    groupSelectOptions (group) {
      const options = group.options.map(o => ({ id: o.id, label: o.label, disabled: false }))
      // A choice made elsewhere (e.g. a reservable option from the storefront) stays visible
      this.groupChildItems(group).forEach(child => {
        if (!options.find(o => o.id === String(child.product_id))) {
          options.push({ id: String(child.product_id), label: child.product_name, disabled: true })
        }
      })
      return options
    },
    /**
     * Activity pricing: choose the option of a choice group (JDEV-3244). The option is added as a child line of this
     * line, like the storefront adds it. The previous choice of the group is removed first.
     */
    async chooseGroupOption (group, value) {
      if (this.optionsBusy) {
        return
      }
      const current = this.groupChildItems(group)
      if (value && current.some(c => String(c.product_id) === String(value))) {
        return
      }
      const option = value ? group.options.find(o => o.id === String(value)) : null
      if (value && !option) {
        return
      }
      this.optionsBusy = true
      try {
        for (const child of current) {
          await this.$store.dispatch('deleteItemFromBasket', {
            id: child.id,
            item: child,
            shopId: this.shopId,
            index: this.index
          })
        }
        if (option) {
          await this.$store.dispatch('addToBasket', {
            locale: this.locale,
            shopId: this.shopId,
            masterShopId: this.masterShopId,
            product: option.product,
            count: option.count,
            item: this.item,
            item_id: this.item.id // Shows the tentative line under its parent until the basket is reloaded
          })
        }
      } catch (err) {
        this.showAddedToBasketError(err)
      }
      try {
        await this.$store.dispatch('reloadBasket', this.shopId + '-' + this.$store.state.activeBasket)
      } catch (e) {}
      this.optionsBusy = false
    },
    async addItem () {
      let item = this.item
      let shopId = this.shopId
      item.price = this.validatedPrice(item.price)
      try {
        const data = {
          locale: this.locale,
          shopId: shopId,
          masterShopId: this.masterShopId,
          count: item.count,
          price: item.price,
          vat: item.vat
        }
        if (this.isFreeformItem) {
          data.productName = item.product_name
          data.special = item.special
          if (this.isNetvisorVisible) {
            data.netvisorAccount = item.netvisoraccount
            data.netvisorVatcode = item.netvisorvatcode
          }
          if (this.isLoyaltyVisible) {
            data.loyalty = item.loyalty
          }
        }
        await this.$store.dispatch('addToBasket', data)
      } catch (err) {
        this.showAddedToBasketError(err)
      }
      this.itemModificationEnabled = false
    },
    async modifyTicketItem (option) {
      let item = this.item
      let shopId = this.shopId
      try {
        await this.$store.dispatch('modifyBasketItem', {
          locale: this.locale,
          shopId: shopId,
          masterShopId: this.masterShopId,
          id: item.id,
          count: item.count,
          price: this.selectedTicketProductPrice,
          product_id: option.id
        })
      } catch (err) {
        this.showAddedToBasketError(err)
      }
      this.selectedTicketProductId = null
    },
    async expandItem () {
      let item = this.item
      let shopId = this.shopId
      try {
        await this.$store.dispatch('modifyBasketItem', {
          locale: this.locale,
          shopId: shopId,
          masterShopId: this.masterShopid,
          id: item.id,
          split: true
        })
      } catch (err) {
        this.showAddedToBasketError(err)
      }
      this.selectedTicketProductId = null
    },
    confirmItemRemoval () {
      let msg = ''
      if (this.findChildren().length) {
        msg += this._('All linked items such as tickets and options will also be removed.') + ' '
      }
      if(this.item.reservation_timestart) {
        msg += this._('The reservation will be cancelled.') + ' '
      }
      msg += this._('The removal happens instantly and cannot be reverted.')

      this.showDialog({
        title: this._('Are you sure you want to remove this item?'),
        text: msg,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Remove'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.doDeleteItem()
            }
          }
        ]
      })
    },
    async deleteItem () {
      if (this.item && this.item.order_id) {
        this.confirmItemRemoval()
        return
      } else {
        this.doDeleteItem()
      }
    },
    async doDeleteItem () {
      let item = this.item
      let shopId = this.shopId
      await this.$store.dispatch('deleteItemFromBasket', {
        id: item.id,
        item: item,
        shopId: shopId,
        index: this.index
      })
      // This probably does nothing
      this.$emit('deleteItemFromBasket', { item: item, shopId: shopId })
      // this.trackRemovedFromBasket(item) // this is done in store/index.js
    },
    /*
    trackRemovedFromBasket (item) {
      this.EventBus.$emit('removedFromBasket', item)
    },
    */
    matchHeight: debounce(
      function () {
        if (process.browser) {
          // jQuery('.match-row').matchHeight()
        }
      }, 100
    ),
    async toggleUpsell () {
      this.isOpen = !this.isOpen
      let $this = this
      await nextTick()
      $this.$Lazyload.lazyLoadHandler()
    }
  },
  computed: {
    ...mapGetters(['apiKey', 'selfService', 'dateFormat', 'timeFormat', 'numberFormat', 'timezone']),
    clientId () {
      return this.$store.state.clientid
    },
    isSeatInformationVisible () {
      if (this.parent !== 'orderdetails') {
        return false
      }
      if (!this.resources.length) {
        return false
      }
      return true
    },
    resources () {
      return this.reservation ? this.reservation.sharedResource : []
    },
    // Activity pricing: ticket type rule and choice group warnings never block POS, they are only shown
    itemWarnings () {
      const list = (v) => !v ? [] : (Array.isArray(v) ? v : Object.values(v))
      const warnings = [...list(this.item.rule_warnings), ...list(this.item.optiongroups_missing)]
      // Product form: a missing mandatory answer is only a warning in POS (JDEV-3245)
      if (this.isFormIncomplete) {
        warnings.push({ message: this._('Fill in the required fields of the form "%s".').replace('%s', this.item.form.name || '') })
      }
      return [...new Set(warnings.filter(w => w && w.message).map(w => w.message))]
    },
    formFields () {
      const form = this.item && this.item.form
      if (!form || !form.fields) {
        return []
      }
      let fields = form.fields
      if (typeof fields === 'string') {
        try {
          fields = JSON.parse(fields)
        } catch (e) {
          return []
        }
      }
      if (!fields || typeof fields !== 'object') {
        return []
      }
      return (Array.isArray(fields) ? fields : Object.values(fields)).filter(f => f && typeof f === 'object')
    },
    hasForm () {
      return !!(this.item && this.item.form && this.item.form.id && this.formFields.some(f => this.isFormAnswerField(f)))
    },
    isFormIncomplete () {
      if (!this.hasForm) {
        return false
      }
      const answers = this.parseFormResponse(this.item.formresponse)
      return this.formFields.some(f => this.isFormFieldMissing(f, answers))
    },
    // Activity pricing: the product has options in choice groups (JDEV-3244)
    hasOptionGroupLinks () {
      if (!this.item || !this.item.id || this.item.id === 'new' || this.hasParentItem || !this.item.product_id || !this.item.product) {
        return false
      }
      const links = this.item.product.ownLinkedproduct
      if (!links) {
        return false
      }
      return (Array.isArray(links) ? links : Object.values(links)).some(lp => lp && parseInt(lp.type, 10) === this.LINKEDPRODUCT_OPTIONAL && lp.optiongroup_id)
    },
    isOptionGroupEditorVisible () {
      return this.hasOptionGroupLinks && (this.optionsLoading || this.optionGroups.length > 0)
    },
    optionGroups () {
      const product = this.optionProduct
      if (!product || String(product.id) !== String(this.item.product_id)) {
        return []
      }
      const list = (v) => !v ? [] : (Array.isArray(v) ? v : Object.values(v))
      const links = list(product.ownLinkedproduct).filter(lp => lp && parseInt(lp.type, 10) === this.LINKEDPRODUCT_OPTIONAL && lp.optiongroup_id)
      const products = list(product.sharedProduct)
      return list(product.ownOptiongroup)
        .slice()
        .sort((a, b) => (Number(a.priority) || 0) - (Number(b.priority) || 0))
        .map(group => {
          const isPlaceGroup = group.role === 'pickup' || group.role === 'dropoff'
          const groupLinks = links.filter(lp => String(lp.optiongroup_id) === String(group.id))
          const options = []
          let unsupported = false
          groupLinks.forEach(lp => {
            const p = products.find(sp => String(sp.id) === String(lp.linkedproduct_id))
            if (!p || parseInt(p.deleted, 10)) {
              return
            }
            if (isPlaceGroup || !this.isPickableOption(p)) {
              unsupported = true
              return
            }
            const count = this.optionCount(lp)
            const name = parseInt(p.usemarketingname, 10) && p.marketingname ? p.marketingname : p.name
            let label = name
            if (parseInt(lp.includeinprice, 10)) {
              label += ' (' + this._('Included') + ')'
            } else if (p.price !== undefined && p.price !== null && p.price !== '') {
              label += ' (' + (count !== 1 ? count + ' × ' : '') + this.$filters.currency(this.validatedPrice(p.price), p.currency || this.item.currency) + ')'
            }
            options.push({ id: String(lp.linkedproduct_id), label, product: p, count })
          })
          return {
            id: group.id,
            name: group.name,
            required: !!parseInt(group.required, 10),
            optionIds: groupLinks.map(lp => String(lp.linkedproduct_id)),
            options,
            unsupported
          }
        })
        .filter(group => group.optionIds.length > 0)
    },
    parentDays () {
      if (!this.item.start_ts || !this.item.end_ts) {
        return 1
      }
      return Math.max(1, Math.round((Number(this.item.end_ts) - Number(this.item.start_ts)) / 86400))
    },
    // The rate plan is part of reservation_desc, which isn't shown when the time is formatted from the timestamps
    isRateplanNameVisible () {
      if (!this.item.rateplan_name) {
        return false
      }
      return !String(this.getFullReservationDesc(this.item) || '').startsWith(this.item.rateplan_name)
    },
    seats () {
      return this.reservation ? this.reservation.sharedSeat : []
    },
    reservation () {
      return this.item.ownReservation && this.item.ownReservation[0] ? this.item.ownReservation[0] : null
    },
    isOkButtonEnabled () {
      return this.item && !!this.item.product_name
    },
    totalPrice: {
      get () {
        if (!this.item.price) {
          return 0
        }
        const count = Number.isFinite(parseFloat(this.item.count)) ? this.item.count : 0
        return new Decimal(this.item.price).times(count).times(this.item.resource_count > 1 ? this.item.resource_count : 1).toDecimalPlaces(2).toNumber()
      }, 
      set (newValue) {
        newValue = newValue.replace(/[^0-9.,-]/g, '')
        if (newValue === '') {
          return
        }
        const count = Number.isFinite(parseFloat(this.item.count)) && parseFloat(this.item.count) !== 0 ? this.item.count : 1
        this.item.price = new Decimal(this.cleanAndConvertNumber(newValue)).dividedBy(count).times(this.item.resource_count > 1 ? this.item.resource_count : 1).toDecimalPlaces(3).toString()
      }
    },
    totalVatFree () {
      if (!parseFloat(this.item.vat)) {
        return this.totalPrice
      }
      if (!this.item.price) {
        return 0
      }
      const count = Number.isFinite(parseFloat(this.item.count)) ? this.item.count : 0
      return new Decimal(this.item.price).times(count).times(this.item.resource_count > 1 ? this.item.resource_count : 1).dividedBy(1 + (this.item.vat / 100)).toDecimalPlaces(2).toNumber()
    },
    vatFreePrice: {
      get () {
        if (!parseFloat(this.item.vat) || !parseFloat(this.item.price)) {
          if (this.item.price === null) {
            return ''
          }
          return '' + this.item.price
        }
        return new Decimal(this.item.price).dividedBy(1 + (this.item.vat / 100)).toDecimalPlaces(3).toString()
      },
      set (newValue) {
        if (!parseFloat(this.item.vat)) {
          this.item.price = newValue
          return
        }
        this.item.price = new Decimal(newValue).times(1 + (this.item.vat / 100)).toDecimalPlaces(3).toString()
      }
    },
    isNetvisorVisible () {
      return this.isFreeformItem && this.isNetvisorConfigured && this.netvisorAccounts && this.netvisorAccounts.length > 0
    },
    isLoyaltyVisible () {
      return this.isFreeformItem && this.settings.pay_option17_loyalty
    },
    isPaymentMethodBenefitEnabled () {
      return this.settings.pay_option17_loyalty === 'both'
    },
    isExtractionAvailable () {
      return this.isTicket && this.parent === 'openticketlist'
    },
    ticketOptions () {
      let returnValues = [];
      let item = this.item;
      let $this = this
      if (typeof item === 'undefined' || typeof this.ticketProducts == '') {
        return returnValues
      }
      this.ticketProducts.forEach(function(element) {
        if((!element.voucher_ids) || element.id === $this.item.product_id) {
          returnValues.push({ name: $this.item.count + ' x ' + (parseInt(element.usemarketingname) ? element.marketingname : element.name), id: element.id })
        }
      })
      return returnValues
    },
    productNameExtras () {
      if (this.item && this.item.price == 0) {
        return 'zeroprice'
      }
      return ''
    },
    itemType () {
      if (this.isShowLike) {
        return 'show'
      }
      if (this.isTicket) {
        return 'ticket'
      }
      if (this.hasParentItem) {
        return 'option'
      }
      if (this.isDiscount) {
        return 'discount'
      }
      return 'generic'
    },
    itemExtras () {
      let currentId = this.item.id
      let siblings = this.findSiblings()
      let extraStr = ' '
      if(siblings.length > 0) {
        if(siblings[siblings.length-1].id == currentId) {
          extraStr += 'last-child '
        }
        if(siblings[0].id == currentId) {
          extraStr += 'first-child '
        }
      }
      return extraStr.slice(0, -1)
    },
    itemSiblings () {
      let currentId = this.item.id
      let siblings = this.findSiblings()
      let extraStr = ' '
      if(siblings.length > 0) {
        if(siblings[siblings.length-1].id == currentId) {
          extraStr += 'last-child '
        }
        if(siblings[0].id == currentId) {
          extraStr += 'first-child '
        }
      }
      return siblings
    },
    displayedCount () {
      let item = this.item
      let itemUnit = this._('pcs')
      let itemSumUnit = ''
      switch (parseInt(item.product_unittype)) {
        case 1:
          if (parseInt(item.product_unit) !== 0) {
            itemUnit = this._('min')
          }
          break
        case 2:
          itemUnit = this._('h')
          break
        case 3:
          itemUnit = this._('d')
          break
      }
      let multiple = 1
      if (item.resource_count) {
        multiple = parseInt(item.resource_count, 10)
      }
      if (parseInt(item.product_unit, 10) > 1) {
        itemUnit = this.$convertToHoursAndMinutes(item.product_unit + ' ' + itemUnit)
        itemSumUnit = '&times; ' + itemUnit
        if (multiple > 1) {
          itemSumUnit += ' &times; ' + multiple + ' ' + this._('pcs')
        }
      } else {
        itemSumUnit = itemUnit
        if (multiple > 1) {
          itemSumUnit += ' &times; ' + multiple + ' ' + this._('pcs')
        }
      }
      if (parseInt(item.hide_units) && parseInt(item.start_ts)) {
        itemUnit = ''
        itemSumUnit = ''
      }
      /*
      var abbrStart = '';
      var abbrEnd = '';
      if(item.reservation_count > 1 || (item.reservation_count > 0 && product.sharedPricetier && product.sharedPricetier.length)) {
        var unitStr = _('pcs');
        if(product.subtype == 1 || product.subtype == this.SUBTYPE_ACTIVITY || (product.sharedPricetier && product.sharedPricetier.length)) {
          unitStr = _('pers');
          abbrStart = '<abbr title="' + this.getPriceTierDescription(product, item) + '">';
          abbrEnd = '</abbr>';
        }
        itemSumUnit += ' (' + abbrStart + item.reservation_count + ' ' + unitStr + abbrEnd + ')';
      }
      */
      let unitStr = ''
      if (item.reservation_count > 1 || (item.reservation_count > 0 && this.priceTiers.length)) {
        unitStr = this._('pcs')
        switch (parseInt(item.product_subtype)) {
          case 1:
          case 2:
          case 3:
            unitStr = this._('pers')
            break
        }
        itemSumUnit += ' (' + item.reservation_count + ' ' + unitStr + ')'
      }
      if (item.origin) {
        return item.reservation_count + ' ' + unitStr
      } else {
        return item.count + ' ' + itemSumUnit
      }
    },
    priceTiers () {
      let item = this.item
      let itemShopId = this.shopId
      let pricetiers = []
      if (item.pricetiers) {
        let ptArr = item.pricetiers.split(';')
        for (var i = 0; i < ptArr.length; i++) {
          let ptItem = ptArr[i].split(':')
          pricetiers.push({
            id: ptItem[0],
            count: ptItem[1],
            name: this.getPricetierName(ptItem[0], itemShopId)
          })
        }
      }
      return pricetiers
    },
    hasVisiblePricing () {
      // return parseInt(this.item.hide_pricing) !== 1 && !this.isShowLike
      if (this.item && this.item.price == 0) {
        return false
      }
      return !this.isShowLike
    },
    isLocked () {
      if (this.item && parseInt(this.item.locked)) {
        return true
      }
      return false
    },
    isReal () {
      if (this.item.id) {
        return true
      }
      return false
    },
    isReservation () {
      if (this.item && this.item.start_ts) {
        return true
      }
      return false
    },
    isDiscount () {
      if (this.item && this.item.discount_id) {
        return true
      }
      return false
    },
    isDiscountSelectorAvailable () {
      return !this.isDiscount && this.shopId === this.masterShopId
    },
    isDescriptionEditable () {
      if (this.receiptData && parseInt(this.receiptData.enableBilling)) {
        return true
      }
      return false
    },
    isCountEditable () {
      return !this.isTicket
    },
    isVatEditable () {
      if (this.receiptData && parseInt(this.receiptData.enableBilling)) {
        return true
      }
      return false
    },
    isReadOnly () {
      return !!this.readonly
    },
    isEditable () {
      return !this.isReadOnly && !this.isShowLike && !this.isLocked && this.isReal
    },
    isDeletable () {
      return !this.isReadOnly && !this.isLocked && this.isReal && !this.hasParentItem
    },
    isPriceVisible () {
      return !this.isReadOnly && (!this.isTicket || true) 
    },
    isPriceEditable () {
      return !this.isReadOnly && (!this.isTicket || true) && this.shopId === this.masterShopId
    },
    isTicket () {
      return this.item.product_subtype == 5 // SUBTYPE_TICKET
    },
    isShow () {
      return this.item && this.item.product && this.item.product.type == 1 && this.item.product.subtype == 4 && !!this.item.show_id
      // return !!this.item.show_id
    },
    isShowLike () {
      return this.item && this.item.product && this.item.product.type == 1 && ((this.item.product.subtype == 4 && !!this.item.show_id) || parseInt(this.item.product.hide_pricing,10) == 5)
      // return !!this.item.show_id
    },
    isFreeformItem () {
      if (!this.item.product_id && !this.item.discount_id && !this.item.item_id && !this.item.commission_id && !this.item.valuecard_id && !this.item.voucher_id) {
        return true
      }
      return false
    },
    hasParentItem () {
      return this.item && this.item.item_id
    },
    showFolioCheckbox () {
      return !!(this.folioSelectable && this.item && this.item.id && this.item.id !== 'new' && !this.hasParentItem && !this.item.modifier_id && !this.item.discount_id && !parseInt(this.item.isdelivery))
    },
    multiple () {
      if (this.item.resource_count && parseInt(this.item.resource_count, 10) > 1) {
        return parseInt(this.item.resource_count, 10)
      }
      return 1
    },
    selectedTicketProductPrice () {
      if (!this.selectedTicketProductId || !this.ticketProducts || !this.ticketProducts.length) {
        return 0
      }
      for (var i = 0; i < this.ticketProducts.length; i++) {
        if (this.ticketProducts[i].id == this.selectedTicketProductId) {
          return this.ticketProducts[i].price
        }
      }
      return 0
    },
    upsellProducts () {
      let $this = this
      if (this.upsellProductCache && this.upsellProductCache[this.item.product.id]) {
        return this.upsellProductCache[this.item.product.id]
      }
      if (!this.item.product || !this.item.product.ownLinkedproduct || !this.item.product.ownLinkedproduct.length) {
        this.upsellProductCache = []
        return this.upsellProductCache
      }
      let urlArray = []
      let doneIds = []
      for (var i = 0; i < this.item.product.ownLinkedproduct.length; i++) {
        if (parseInt(this.item.product.ownLinkedproduct[i].type, 10) === 1 && doneIds.indexOf(this.item.product.ownLinkedproduct[i].linkedproduct_id) === -1) {
          urlArray.push(axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products/' + this.item.product.ownLinkedproduct[i].linkedproduct_id + '.json?version=' + this.locale))
          doneIds.push(this.item.product.ownLinkedproduct[i].linkedproduct_id)
        }
      }
      axios.all(urlArray)
      .then(axios.spread(function () {
        let ret = []
        for (var i = 0; i < arguments.length; i++) {
          let p = arguments[i].data
          if (p) {
            ret.push({
              id: p.id,
              source_id: p.id,
              name: parseInt(p.usemarketingname) && p.marketingname ? p.marketingname : p.name,
              type: p.type,
              shopid: $this.shopId,
              product: p
            })
          }
        }
        $this.upsellProductCache = []
        $this.upsellProductCache[$this.item.product.id] = ret
        return ret
      }))
      .catch(function (e) {
        $this.upsellProductCache = []
        return $this.upsellProductCache
      })
    },
    hasUpsellProducts () {
      if (!this.item.product || !this.item.product.ownLinkedproduct || !this.item.product.ownLinkedproduct.length) {
        return false
      }
      for (var i = 0; i < this.item.product.ownLinkedproduct.length; i++) {
        if (parseInt(this.item.product.ownLinkedproduct[i].type, 10) === 1) {
          return true
        }
      }
      return false
    },
    showVatPrices () {
      return true
    },
    showVatFreePrices () {
      return this.isVatVisible
    },
    isPackage () {
      return this.item.packagetotal && (this.item.packages && !this.item.item_id)
    },
    isPackaged () {
      return this.item.packages && this.item.item_id
    }
  },
  watch: {
    /* itemModificationEnabled (val) {
      if (val) {
        if(!this.isTicket) {
          this.$emit('itemModificationStart', this.item)
        }
      } else {
        if(!this.isTicket) {
          this.$emit('itemModificationEnd', this.item)
        }
      }
    } */
    itemModificationEnabled (val) {
      if (val) {
        this.$emit('itemModificationStart', this.item)
      } else {
        this.$emit('itemModificationEnd', this.item)
      }
    }
  },
  created () {
    let $this = this
    this.item = Object.assign({}, this.currItem)
    this.basketItemModifiedHandler = (data) => {
      let item = data.item
      let shopId = data.shopId
      if (!$this.isTicket && item.id === $this.item.id && shopId === $this.shopId) {
        $this.itemModificationEnabled = false
      }
    }
    this.EventBus.$on('basketItemModified', this.basketItemModifiedHandler)
  },
  updated () {
    if (!this.itemModificationEnabled && JSON.stringify(this.item) !== JSON.stringify(this.currItem)) {
      this.item = Object.assign({}, this.currItem)
    }
    if(this.isTicket && this.item && this.item.product_id != this.selectedTicketProductId) {
      this.selectedTicketProductId = this.currItem.product_id
    }
    this.matchHeight()
  },
  mounted () {
    this.netvisorAccounts = this.accounts
    this.upsellProductCache = []
    if(this.item.id === 'new') {
      this.enableItemModification()
    }
    if(this.isTicket) {
      this.showTicketOptions()
    }
    this.matchHeight()
  },
  unmounted () {
    // If this instance is destroyed (e.g. the underlying item was replaced/removed as a
    // side effect of a basket recalculation) while still mid-edit, the itemModificationEnabled
    // watcher never gets a chance to run. Without this, the parent never receives
    // itemModificationEnd for this item's id, permanently hiding the payment/save row.
    if (this.itemModificationEnabled) {
      this.$emit('itemModificationEnd', this.item)
    }
    if (this.basketItemModifiedHandler) {
      this.EventBus.$off('basketItemModified', this.basketItemModifiedHandler)
    }
  },
  directives: {
    cartimage: {
      inserted (el, binding) {
        new Promise(function (resolve, reject) {
          let timeout = 5000
          let timer = null
          let img = new Image()
          img.onerror = img.onabort = function () {
            clearTimeout(timer)
            reject()
          }
          img.onload = function () {
            clearTimeout(timer)
            resolve()
          }
          timer = setTimeout(function () {
            img.src = '//!!!!/test.jpg'
            reject()
          }, timeout)
          img.src = binding.value
        }).then(function () {
          // jQuery(el).css('backgroundImage', 'url(' + binding.value + ')')
        }).catch(function () {
          // jQuery(el).addClass('no-image')
        })
      }
    }
  }
}
</script>

<style scoped>
.dark .js-cart-product-name, .dark .js-cart-product-price {
  color: #ffffff ! important;
}
.dark .js-cart-product-unit {
  color: #98ADB8;
}
.dark .js-cart-product-description {
  color: #dddddd;
}
.js-cart-product-name-editor {
  width: 100%;
  display: inline-block;
}
.js-cart-product-name-editor {
  color: #000;
  font-size: 18px;
  font-weight: bold;
}
.item-modify-totalprice input::-webkit-outer-spin-button,
.item-modify-totalprice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;  
}
.item-modify-totalprice input[type=number] {
  -moz-appearance: textfield;  
}
.js-cart-product.option, .js-cart-product.discount {
  padding-top: 4px !important;
  padding-bottom: 0px !important;
  background: #ebeff1;
}
.js-cart-product.option .product-name-wrap {
  margin-right: 0px;
}
.js-cart-product-content {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}
.product-name-wrap {
  flex: 1;
}
.js-cart-product-remove {
  position: relative;
  margin-left: auto;
  flex: none;
}
.item-modify {
  flex: 1;
}
.folio-item-select {
  flex: none;
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 0 8px 0 0;
  pointer-events: none;
}
.folio-item-select input {
  margin: 0;
  width: 18px;
  height: 18px;
}
.js-cart-product.folio-select-mode {
  user-select: none;
  flex-wrap: nowrap;
  /* Bootstrap's .show { display: block !important } also matches show rows, which breaks the flex layout */
  display: flex !important;
}
.js-cart-product.folio-selectable-row {
  cursor: pointer;
}
/* Sub-items follow their parent when it is selected, so line them up with the parent's name, past the checkbox column */
.js-cart-product.folio-select-mode.folio-sub-row {
  padding-left: 56px !important;
}
/* Ticket rows are normally styled as a grouped sub-row (grey, no padding, no divider). In select mode each one is its own selectable row. */
.js-cart-product.ticket.folio-select-mode {
  background: transparent;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  border-bottom: 1px solid #CFD8DC !important;
}
.js-cart-product.folio-selected-row {
  background-color: #e8f1f8 !important;
}
/*
.zeroprice {
  margin-bottom: 10px !important;
}*/
.description-rateplan {
  display: block;
  font-weight: bold;
}
.cart-product-warnings {
  margin-top: 4px;
}
.cart-product-warning {
  display: block;
  color: #8a6d3b;
  font-size: 12px;
  line-height: 1.4;
}
.dark .cart-product-warning {
  color: #f0ad4e;
}
/* Product options and form fields: the same float-label rows as the rest of the editor. The bottom margin keeps
   room for the floating label of the next row. */
.item-section-title {
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 10px;
}
.item-modify-option, .item-modify-formfield {
  margin-bottom: 10px;
}
.item-modify-checkbox {
  margin: 0;
}
.item-modify-note {
  flex-basis: 100%;
  font-size: 12px;
  color: #8a6d3b;
}
</style>